import { render, staticRenderFns } from "./emma.vue?vue&type=template&id=5e175cbb"
import script from "./emma.vue?vue&type=script&lang=js"
export * from "./emma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports